interface Props {
  id: string;
  title?: string;
  height?: string;
  width?: string;
  maxHeight?: string;
}

const VimeoEmbed = ({ id, title = '', height = 'calc(100vh - 64px)', maxHeight = '1080px', width = '100%' }: Props) => (
  <div>
    <iframe
      src={`https://player.vimeo.com/video/${id}?h=be794a0b3e&badge=0&autopause=0&player_id=0&app_id=58479`}
      frameBorder={0}
      allow="autoplay; fullscreen; picture-in-picture"
      allowFullScreen={false}
      style={{ width, height, maxHeight }}
      title={title}
    />
  </div>
);

export default VimeoEmbed;
